module.exports = __webpack_public_path__ + "assets/retina_InnerTangentDetailed.093f1841903cf1cf759ac1aedce19aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_InnerTangentDetailed.png
// module id = 679
// module chunks = 0